export default function (entity, message) {

    console.log('debugging :', 'component', '\'' + 'command' + '\'');
    console.log(message);
    console.log('debugging :', 'entity', '\'' + entity.name + '\'');
    console.log(entity);
};
